import { showAiLimitNotice } from '@/composables/useAiLimit.js'

export const useApi = () => {

    const config = useRuntimeConfig()
    const { token, setToken } = useAuth()

    // Wspólna konfiguracja: dokleja Bearer i wylogowuje na 401 (np. wygasły JWT).
    const withDefaults = (url: string, options: any = {}) => ({
        baseURL: config.public.apiHost,
        server: false,
        headers: {
            ...(token.value ? { Authorization: `Bearer ${token.value}` } : {}),
            ...(options.headers ?? {}),
        },
        onResponseError({response}: any) {
            // wyczerpany limit AI — jeden wspólny komunikat, niezależnie od funkcji (AiLimitNotice)
            if (response?.status === 429 && response?._data?.code === 'ai_limit') showAiLimitNotice(response._data)
            if (response?.status === 401) {
                setToken(null)
                navigateTo('/login')
            }
        },
        ...options,
    })

    return {
        get: <T>(url: string, options: any = {}) =>
            $fetch<T>(url, withDefaults(url, { cache: 'no-store', key: String(Math.random()), ...options })),
        post: <T>(url: string, body: any) =>
            $fetch<T>(url, withDefaults(url, { method: 'POST', body })),
        patch: <T>(url: string, body: any) =>
            $fetch<T>(url, withDefaults(url, { method: 'PATCH', body })),
        put: <T>(url: string, body: any) =>
            $fetch<T>(url, withDefaults(url, { method: 'PUT', body })),
        delete: <T>(url: string, body?: any) =>
            $fetch<T>(url, withDefaults(url, { method: 'DELETE', body })),
    }
}
